export const carbg = [
  '../../fleet/benz-s-class.jpg',
  '../../fleet/prado_main.jpg',
  '../../fleet/cruz1.png',
  '../../fleet/premio2.jpg',
  '../../fleet/alphard1.jpg',
  '../../fleet/benz-video.mp4',
  '../../fleet/noah1.jpg',
]
